module.exports = __webpack_public_path__ + "static/media/m_nose_bulbous.31d10482.png";